const apolloHeadingOptions = {
  moons: {
    msg: '¡{name}, eres candidato!',
    description: 'Agenda tu cita y obtén la sonrisa de tus sueños'
  },
  possible_advanced: {
    msg: '¡{name}, eres candidato!',
    description: 'Puedes tener la sonrisa de tus sueños con moons'
  },
  no_candidate: {
    msg: '¡Lo sentimos!',
    description: 'Nuestros doctores dicen que no eres candidato'
  },
  need_medical_treatment: {
    msg: '¡{name}! tu caso necesita algo más',
    description: 'Nuestros doctores dicen que necesitamos un pequeño paso más'
  },
  need_extra_info: {
    msg: '¡{name}! necesitamos más información',
    description: 'Nuestro equipo te contactará o puedes contactarnos ahora'
  },
  candidate: {
    msg: '¡{name}, está listo tu pre-diagnóstico!',
    description: 'Agenda tu cita y obtén la sonrisa de tus sueños'
  },
  default: {
    msg: '{name}, aún no tenemos tu pre-diagnóstico',
    description: 'Necesitamos más tiempo para determinar tu caso'
  }
}

export default apolloHeadingOptions
